import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "anot-header" }
const _hoisted_2 = {
  key: 0,
  class: "anot-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "anot-empty"
}
const _hoisted_4 = {
  key: 2,
  class: "anot-list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "anot-card-title" }
const _hoisted_7 = { class: "anot-card-content" }
const _hoisted_8 = { class: "anot-card-meta" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "anot-modal" }
const _hoisted_11 = { class: "anot-modal-header" }
const _hoisted_12 = { class: "anot-modal-body" }
const _hoisted_13 = { class: "anot-modal-footer" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "anot-modal anot-modal--sm" }
const _hoisted_16 = { class: "anot-modal-footer" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["anot-shell", { 'anot-shell--embedded': _ctx.embedded }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.embedded)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "anot-back",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.back()))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
            ], -1),
            _createTextVNode(" Voltar ", -1)
          ]))]))
        : _createCommentVNode("", true),
      _cache[14] || (_cache[14] = _createElementVNode("h1", { class: "anot-title" }, [
        _createElementVNode("svg", {
          width: "18",
          height: "18",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
          _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
        ]),
        _createTextVNode(" Anotações ")
      ], -1)),
      _createElementVNode("button", {
        class: "anot-new-btn",
        type: "button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCreate && _ctx.openCreate(...args)))
      }, [...(_cache[13] || (_cache[13] = [
        _createElementVNode("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("path", { d: "M12 5v14M5 12h14" })
        ], -1),
        _createTextVNode(" Nova anotação ", -1)
      ]))])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando..."))
      : (_ctx.items.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[15] || (_cache[15] = _createElementVNode("svg", {
              width: "48",
              height: "48",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
              _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
            ], -1)),
            _cache[16] || (_cache[16] = _createElementVNode("p", null, "Nenhuma anotação ainda.", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openCreate && _ctx.openCreate(...args)))
            }, "Criar primeira anotação")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (ann) => {
              return (_openBlock(), _createElementBlock("div", {
                key: ann.id,
                class: "anot-card"
              }, [
                _createElementVNode("div", {
                  class: "anot-card-body",
                  onClick: ($event: any) => (_ctx.openEdit(ann))
                }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(ann.title || 'Sem título'), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(ann.content), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formatDate(ann.updatedAt)), 1)
                ], 8, _hoisted_5),
                _createElementVNode("button", {
                  class: "anot-card-delete",
                  type: "button",
                  title: "Apagar",
                  onClick: _withModifiers(($event: any) => (_ctx.confirmDelete(ann)), ["stop"])
                }, [...(_cache[17] || (_cache[17] = [
                  _createStaticVNode("<svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-953f34e6><polyline points=\"3 6 5 6 21 6\" data-v-953f34e6></polyline><path d=\"M19 6l-1 14H6L5 6\" data-v-953f34e6></path><path d=\"M10 11v6M14 11v6\" data-v-953f34e6></path><path d=\"M9 6V4h6v2\" data-v-953f34e6></path></svg>", 1)
                ]))], 8, _hoisted_9)
              ]))
            }), 128))
          ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.modal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "anot-overlay",
            onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.modal.id ? 'Editar anotação' : 'Nova anotação'), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "anot-modal-close",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, [...(_cache[18] || (_cache[18] = [
                  _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5"
                  }, [
                    _createElementVNode("line", {
                      x1: "18",
                      y1: "6",
                      x2: "6",
                      y2: "18"
                    }),
                    _createElementVNode("line", {
                      x1: "6",
                      y1: "6",
                      x2: "18",
                      y2: "18"
                    })
                  ], -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modal.title) = $event)),
                  class: "anot-input",
                  type: "text",
                  placeholder: "Título (opcional)",
                  maxlength: "120"
                }, null, 512), [
                  [_vModelText, _ctx.modal.title]
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modal.content) = $event)),
                  class: "anot-textarea",
                  placeholder: "Escreva sua anotação...",
                  rows: "8",
                  autofocus: ""
                }, null, 512), [
                  [_vModelText, _ctx.modal.content]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  type: "button",
                  class: "anot-btn-cancel",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, "Cancelar"),
                _createElementVNode("button", {
                  type: "button",
                  class: "anot-btn-save",
                  disabled: _ctx.saving || !_ctx.modal.content.trim(),
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveModal && _ctx.saveModal(...args)))
                }, _toDisplayString(_ctx.saving ? 'Salvando...' : 'Salvar'), 9, _hoisted_14)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.deleteTarget)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "anot-overlay",
            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.deleteTarget = null), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_15, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "anot-modal-header" }, [
                _createElementVNode("h2", null, "Apagar anotação?")
              ], -1)),
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "anot-modal-body" }, [
                _createElementVNode("p", { class: "anot-delete-msg" }, "Esta ação não pode ser desfeita.")
              ], -1)),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  type: "button",
                  class: "anot-btn-cancel",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteTarget = null))
                }, "Cancelar"),
                _createElementVNode("button", {
                  type: "button",
                  class: "anot-btn-danger",
                  disabled: _ctx.saving,
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.doDelete && _ctx.doDelete(...args)))
                }, _toDisplayString(_ctx.saving ? 'Apagando...' : 'Apagar'), 9, _hoisted_17)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 2))
}